var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1979",
    "data-name": "Group 1979",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3181",
    "data-name": "Rectangle 3181",
    width: 28,
    height: 28,
    rx: 5,
    transform: "translate(0 0)",
    fill: "#4EB6EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-filter-3957532",
    transform: "translate(6.403 6.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8945",
    "data-name": "Path 8945",
    d: "M105.687,35a.542.542,0,0,0-.462.814l5.892,7.873v5.973a.543.543,0,0,0,.787.489l2.172-1.086a.513.513,0,0,0,.3-.489V43.688l5.892-7.873a.542.542,0,0,0-.462-.814Z",
    transform: "translate(-105.149 -35)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.86a120a5ca3f5bedc0a297bbf126f04e.svg";
export { ForwardRef as ReactComponent };